import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Skin Tags forms
   */
  {
    // 1
    field: 'stagDiagnosed',
    label:
      'Have you been diagnosed with a skin tag by healthcare professional?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label:
              'Some skin tags, if larger in size or afflicted with pus, need further testing to rule out other potential causes.',
            type: 'text',
            name: 'diagnosed',
            placeholder: 'Please type here...'
          }
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    // 2
    field: 'stagLocated',
    label: 'On what area of the body is the skin tag located?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'areaLocated',
      placeholder: 'Please type here...'
    }
  },
  {
    // 3
    field: 'stagLong',
    label: 'For how long have you had this skin tag?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'longLess3', value: 'Less than 3 months ago' },
        { key: 'long3-6', value: 'Between 3 and 6 months ago' },
        { key: 'long6-12', value: 'Between 6 and 12 months ago' },
        { key: 'longMore12', value: 'More than 12 months ago' }
      ]
    }
  },
  {
    // 4
    field: 'stagLesion',
    label:
      'The lesion has not changed in appearance or size in the past six months',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'soft', value: 'It is soft to the touch' },
        { key: 'coloured', value: 'The skin is coloured/tan/brown' },
        { key: '1-3mm', value: 'It is 1 to 3 mm in size' },
        {
          key: 'larger3mm',
          value: 'It is larger than 3 mm',
          answer: {
            type: 'text',
            label: 'Please describe',
            name: 'larger3mmDesc',
            placeholder: 'Please type here...'
          }
        },
        {
          key: 'pusForming',
          value: 'There is pus forming',
          answer: {
            type: 'text',
            label: 'Please describe',
            name: 'pusFormingDesc',
            placeholder: 'Please type here...'
          }
        }
      ]
    }
  },
  {
    // 5
    field: 'stagUploadPicture',
    label:
      'Unless it is on a private body part, please upload a picture of your skin tag.',
    type: 'file_upload',
    answer: [
      {
        resourceId: 'skinTagPicture',
        buttonLabel: 'Choose file',
        required: false
      }
    ]
  }
];

export default questionsModels;
